module.exports = __webpack_public_path__ + "img/philips_heartstart-MRx-black.931b1f60.png";